import React, {createContext, useContext} from "react";
import {findSlaMonthData} from "../slaCompareMonthUtils";

const CompareMonthCellsContext = createContext(null);

export function CompareMonthCellsProvider({data, dateList, children}) {
    return (
        <CompareMonthCellsContext.Provider value={{data, dateList}}>
            {children}
        </CompareMonthCellsContext.Provider>
    );
}

export function CompareMonthCells({children}) {
    const ctx = useContext(CompareMonthCellsContext);
    if (!ctx?.dateList?.length) {
        return null;
    }

    const {data, dateList} = ctx;

    return dateList.map((month) => {
        const raw = findSlaMonthData(data, month.id);

        if (!raw) {
            return (
                <td
                    key={month.id}
                    className="fieldset-td sla-compare-month-col sla-compare-month-col--empty"
                />
            );
        }

        const content = children(raw);
        const isMuted = content == null || content === "";

        return (
            <td
                key={month.id}
                className={
                    isMuted
                        ? "fieldset-td sla-compare-month-col sla-compare-month-col--muted"
                        : "fieldset-td sla-compare-month-col"
                }
            >
                {isMuted ? "" : content}
            </td>
        );
    });
}
